/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/

import breakpoints from '@userzoomlibraries/toolkit-themes-userzoom-platform-globals/breakpoints';

import { Namespaces } from './i18n';

// @toolkit SMALL.BREAKPOINT_MIN
export const UiBreakpoint = breakpoints.small - 1;

export const Devices = {
	Mobile: 'mobile',
	Tablet: 'tablet',
	Desktop: 'desktop',
	Any: '*',
} as const;

export const Browsers = {
	Chrome: 'chrome',
	Firefox: 'firefox',
	Safari: 'safari',
	Edge: 'edge',
	MobileSafari: 'mobile_safari',
	Any: '*',
} as const;

export const Os = {
	Ios: 'ios',
	Android: 'android',
	WindowsPhone: 'windows_phone',
	BlackBerry: 'blackberry',
	MacOs: 'mac_os',
	Windows: 'windows',
	Linux: 'linux',
	Any: '*',
} as const;

// Do not change ordering
export const AndroidVersionNames = [
	{ number: '1', name: 'No codename' },
	{ number: '1', name: 'No codename' },
	{ number: '1.5', name: 'Cupcake' },
	{ number: '1.6', name: 'Donut' },
	{ number: '2', name: 'Eclair' },
	{ number: '2', name: 'Eclair' },
	{ number: '2', name: 'Eclair' },
	{ number: '2.2', name: 'Froyo' },
	{ number: '2.3', name: 'Gingerbread' },
	{ number: '2.3', name: 'Gingerbread' },
	{ number: '3', name: 'Honeycomb' },
	{ number: '3', name: 'Honeycomb' },
	{ number: '3', name: 'Honeycomb' },
	{ number: '4', name: 'Ice Cream Sandwich' },
	{ number: '4', name: 'Ice Cream Sandwich' },
	{ number: '4.1', name: 'Jelly Bean' },
	{ number: '4.1', name: 'Jelly Bean' },
	{ number: '4.1', name: 'Jelly Bean' },
	{ number: '4.4', name: 'KitKat' },
	{ number: '4.4', name: 'KitKat' },
	{ number: '5', name: 'Lollipop' },
	{ number: '5', name: 'Lollipop' },
	{ number: '6', name: 'Marshmallow' },
	{ number: '7', name: 'Nougat' },
	{ number: '7', name: 'Nougat' },
	{ number: '8', name: 'Oreo' },
	{ number: '8', name: 'Oreo' },
	{ number: '9', name: 'Pie' },
	{ number: '10', name: 'Android' },
	{ number: '11', name: 'Android' },
] as const;

const htmlTabTitleKeys: { [route: string]: string } = {
	'study-restrictions': `${Namespaces.Common}:restrictions.htmlTitle`,
	forbidden: `${Namespaces.Common}:forbidden.htmlTitle`,
	'not-found': `${Namespaces.Common}:errorPage.404.htmlTitle`,
	'unexpected-error': `${Namespaces.Common}:errorPage.default.htmlTitle`,
	'install-app': `${Namespaces.Common}:installApp.htmlTitle`,
};

export const getHtmlTabTitleKey = (route: string): string => {
	if (htmlTabTitleKeys[route]) {
		return htmlTabTitleKeys[route];
	}
	return `${Namespaces.Common}:userzoomStudy`;
};

export const trusteSeal = {
	image: 'http://privacy-policy.truste.com/privacy-seal/seal?rid=e599448b-ec7a-4029-9bff-3b7edf32908e',
	link: 'http://privacy.truste.com/privacy-seal/validation?rid=e599448b-ec7a-4029-9bff-3b7edf32908e',
};

export enum ExtensionStatus {
	Pending = 'pending',
	NotInstalled = 'notInstalled',
	Installed = 'installed',
	Outdated = 'outdated',
	Uninstalled = 'uninstalled',
}

export const ExtensionEvents = {
	CheckExtensionVersion: 'checkExtensionVersion',
	ExtensionVersionResponse: 'extensionVersionResponse',
	UpdateExtension: 'updateExtension',
	ExtensionUpdated: 'extensionUpdated',
	ExtensionUninstalled: 'extensionUninstalled',
	UninstallExtension: 'uninstallExtension',
	RedirectToExtension: 'redirectToExtension',
};

export enum ParticipantStatuses {
	Complete = 'complete',
	ScreenedOut = 'screenedOut',
	Candidate = 'candidate',
	ScreenerEntered = 'screenerEntered',
	StudyEntered = 'studyEntered',
	Qualified = 'qualified',
	Disqualified = 'disqualified',
	Speeder = 'speeder',
	Cheater = 'cheater',
	StudyClosed = 'studyClosed',
}

export const ExtensionCheckTimeOut = 3000;

export const gqlQuestionTypes: Record<string, string> = {
	oneanswer: 'choice',
	oneansco: 'choice',
	mulanswer: 'choice',
	rankorder: 'rankOrder',
	opencomm: 'openEnded',
	openmorel: 'openEnded',
	ratingone: 'matrix',
	ratingchk: 'matrix',
	ratingoneh: 'matrix',
	ratinghor: 'matrix',
	ratingnps: 'matrix',
	textonly: 'textOnly',
	itracking: 'clickTest',
	treetest: 'treeTest',
	itimeout: 'timeout',
};

export const Splits = {
	newTasksUi: 'participant-experience-tasks-ui',
};
